import React from "react";

const linkify = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return part;
  });
};

const EventList = ({ events, highlightedDate, viewingMonth }) => {
  const months = {};
  const now = new Date();

  const base = new Date(viewingMonth);
  const start = new Date(base.getFullYear(), base.getMonth(), 1);
  const end = new Date(base.getFullYear(), base.getMonth() + 3, 0);

  Array.isArray(events) &&
    events.forEach((event) => {
      const startDate = new Date(event?.date);
      const endDate = event?.end ? new Date(event.end) : null;
      const isRange = endDate && endDate.toDateString() !== startDate.toDateString();

      if (startDate > end || (endDate && endDate < start)) return;

      const key = startDate.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      const id =
        startDate.getFullYear() * 10000 +
        (startDate.getMonth() + 1) * 100 +
        startDate.getDate();

      if (!months[key]) months[key] = [];

      const isPast = (endDate || startDate) < now;

      months[key].push({
        id,
        date: isRange
          ? `${startDate.toLocaleDateString()} – ${endDate.toLocaleDateString()}`
          : startDate.toLocaleDateString(),
        isoStart: startDate.toISOString().split("T")[0],
        summary: event.title,
        description: event?.description || "",
        location: event?.location || "",
        isPast,
        startTime: startDate.getTime(),
      });

      months[key].sort((a, b) => a.startTime - b.startTime);
    });

  return (
    <div className="event-list" role="region" aria-label="Upcoming events by month">
      {Object.keys(months).length === 0 ? (
        <p style={{ color: "white" }}>No events to display.</p>
      ) : (
        Object.entries(months).map(([month, items]) => (
          <div key={month} className="event-month">
            <h4>{month}</h4>
            <ul role="list">
              {items.map((item, index) => (
                <li
                  key={index}
                  data-event-date={item.id}
                  role="listitem"
                  className={`${highlightedDate === item.id ? "highlighted" : ""} ${
                    item.isPast ? "past-event" : ""
                  }`}
                >
                  <strong>
                    <time dateTime={item.isoStart}>
                      {item.date}
                    </time>
                    {item.isPast ? " Past Event" : ""}
                  </strong>
                  : {item.summary}
                  {item.location && (
                    <div className="event-location">📍 {item.location}</div>
                  )}
                  <div className="event-description">
                    {linkify(item.description)}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};

export default EventList;
